<template>
  <v-form @submit.prevent="submit">
    <div class="d-flex flex-column align-center">
      <h2 class="header">Ξεχάσατε το συνθηματικό σας;</h2>
      <p
        class="paragraph text-center"
      >Κανένα πρόβλημα, εισάγετε το email σας και θα σας στείλουμε οδηγίες για να δημιουργήσετε ένα νέο συνθηματικό</p>
      <v-text-field
        v-model="email"
        :error-messages="emailErrors"
        color="rgb(0,170,221)"
        prepend-inner-icon="mdi-email-outline"
        label="Email"
      ></v-text-field>
      <v-btn
        rounded
        depressed
        type="submit"
        color="rgb(0,170,221)"
        class="white--text text-capitalize btn"
        height="40"
        :loading="localLoading"
      >
        <p class="mb-0">Αίτημα για νέο συνθηματικό</p>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Axios from "axios";

const failed = function() {
  return !this.wentwrong;
};

export default {
  mixins: [validationMixin],
  data() {
    return {
      email: "",
      localLoading: false,
      wentwrong: false
    };
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.localLoading = true;
        Axios.post(`${process.env.VUE_APP_BASE_URL}/user/requestPassReset`, {
          email: this.email
        })
          .then(res => {
            this.localLoading = false;
            this.$router.push("/forgot-message");
            console.log(res);
          })
          .catch(err => {
            this.wentwrong = true;
            this.localLoading = false;
            console.log(err);
          });
      }
    }
  },
  validations: {
    email: {
      required,
      email,
      failed
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Πρέπει να είναι σωστό email");
      if (!this.$v.email.failed)
        errors.push("Κάτι πήγε στραβά. Δοκιμάστε ξανά.");
      return errors;
    }
  },

  watch: {
    email(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.wentwrong = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 150px;
}
.paragraph {
  padding: 0 50px;
  margin-top: 20px;
}

.btn {
  margin-top: 50px;
}
</style>